import { Link, useLocation, useNavigate } from "react-router-dom"
import { appRoutes } from "../routes"
import { useAuthUser, useLogout } from "../hooks/useAuth"
import { isFullScope } from "../constants"
import routePaths from "../constants/path"
import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/react"
import cn from "../utils/cn"
import { intersection } from "lodash"
import Loader from "./Loader"
import { env } from "../config/env"

const Navbar = () => {
  const location = useLocation()
  const { data } = useAuthUser()
  const navigate = useNavigate()
  const { mutate, isPending } = useLogout()

  const user = data?.data ?? null
  const isAuthenticated = isFullScope(data?.scope)

  const handleLogout = () => {
    mutate(undefined, {
      onSuccess: () => {
        navigate(routePaths.login)
      },
    })
  }

  return (
    <nav className="flex items-center py-4 px-8 gap-10 bg-primary shadow-md text-white fixed top-0 left-0 right-0 z-50">
      <div className="flex items-center">
        <img alt="logo" className=" h-12" src="/logo.png" />
      </div>
      {isAuthenticated && (
        <>
          <div className="flex items-center gap-5 ml-8">
            {appRoutes
              ?.filter(
                (route) =>
                  route?.isMenuItem &&
                  intersection(route.canAccess, user?.role).length > 0
              )
              ?.map((route) => (
                <div
                  key={route.path || route.name}
                  className="flex flex-col gap-1"
                >
                  <div className="relative group">
                    <Menu>
                      <MenuButton className="inline-flex items-center text-sm/6 font-semibold hover:text-secondary focus:outline-none">
                        {route.path ? (
                          <Link
                            className={
                              location.pathname === route.path
                                ? "text-secondary"
                                : "text-white hover:text-secondary"
                            }
                            to={route.path || "#"}
                          >
                            {route.name}
                          </Link>
                        ) : (
                          route.name
                        )}
                        {route.children?.length > 0 && (
                          <span className="material-icons">expand_more</span>
                        )}
                      </MenuButton>
                      {route.children?.length > 0 && (
                        <MenuItems
                          transition
                          anchor="bottom end"
                          className="mt-3 flex flex-col bg-white rounded-xl border p-1 text-sm/6  transition duration-100 focus:outline-none data-[closed]:scale-95 data-[closed]:opacity-0"
                          style={{ zIndex: "100" }}
                        >
                          {route.children.map((childRoute) => (
                            <MenuItem
                              key={childRoute.path}
                              className="hover:text-secondary"
                            >
                              <Link
                                key={childRoute.path}
                                className="px-4 py-2"
                                to={childRoute.path}
                              >
                                {childRoute.name}
                              </Link>
                            </MenuItem>
                          ))}
                        </MenuItems>
                      )}
                    </Menu>
                  </div>
                  {location.pathname === route.path && (
                    <div className="w-full h-1 bg-secondary rounded-full"></div>
                  )}
                </div>
              ))}
          </div>
          <a
            className="flex items-center text-sm/6 text-white underline ml-auto cursor-pointer"
            href={env.REACT_APP_TECHNICIAN_PORTAL_URL}
            rel="noopener noreferrer"
            target="_blank"
          >
            Go to Technician Portal
          </a>
        </>
      )}
      <button
        className={cn(
          "flex items-center gap-3 bg-secondary px-4 py-2 rounded-lg disabled:opacity-60 disabled:cursor-not-allowed ml-auto"
        )}
        disabled={isPending}
        onClick={handleLogout}
      >
        {isPending && <Loader className="h-4 w-4 mb-1" />}
        Logout
      </button>
    </nav>
  )
}

export default Navbar
